import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/Missions.css";

const IntroductionCard = {
    borderRadius: "20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const IntroductionCardHeader = {
    fontFamily: "IranSans",
    color: "#174561",
    fontSize: "1.1em",
    paddingRight: "10px",
    paddingTop: "3px"
}
const Vision = props => {

    return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
                    <div style={IntroductionCard}>
                        <Margin top={5}></Margin>
                        <Row>
                            <Col span={16}>
                                <div style={{ backgroundColor: "#f5f5f5", height: "100%", borderRadius: "20px 0 0 20px", padding: "30px" }}>
                                    <p className="textParagraph">
                                    ایرانیان با شعار مراقب بیمه ( حافظ رابطه بیمه گر و بیمه گذار) بر آن شد در ده سال اول یعنی  تا سال ۱۴۰۱ همه ایران را پوشش دهد و جیب هر ایرانی تبدیل به یکی از شعب ایرانیان پوشش شود که خوشبختانه از طریق سوپر اپلیکیشن سپر و ایجاد شعبه در تمام مراکز استانهای کشور و کارشناس سیار در شهرستا های تابعه توانسته به این اهداف بزرگ برسد.                                         <br/>
                                    ما در صدد هستیم تا ۵ سال دیگر به جایگاه ذیل دست یابیم:
                                    <br/>
                                        • تبدیل شدن به تخصصی‌ترین و بزرگترین شرکت ارزیابی خسارت و ریسک در تمامی حوزه های بیمه ای
                                        <br/>
                                        •  تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات وکالت و داوری در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات تحقیق و کارآگاهی در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • هلدینگ ایرانیان پوشش بدون رقیب در حوزه ارزیابی خسارت و خدمات حقوقی بیمه ای از نظر کیفیت، قیمت و سرعت مبتنی بر تکنولوژی در ارائه خدمات خواهد بود.
                                    </p>
                                </div>
                            </Col>
                            <Col span={8} style={{ direction: "rtl", textAlign: "right" }}>
                                <div className="miniCardTitleBorder" style={{
                                    position: 'absolute', left: '50%', top: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }}>                                      
                                    <p className="miniCardTitle"><strong>چشم انداز ۱۴۰۱</strong></p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
    ) : props.size === "tablet" ? (
            <div>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                <Center>
                                    <Margin top={4}>
                                        <div>
                                            <p className="cardTitleTablet"><strong>چشم انداز ۱۴۰۱</strong></p>
                                        </div>
                                    </Margin>
                                </Center>
                                <Center>
                                    <hr className="cardTitleHRTablet" />
                                </Center>
                                <Margin top={2}></Margin>
                                <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                <p className="textParagraphTablet">
                                    ایرانیان با شعار مراقب بیمه ( حافظ رابطه بیمه گر و بیمه گذار) بر آن شد در ده سال اول یعنی  تا سال ۱۴۰۱ همه ایران را پوشش دهد و جیب هر ایرانی تبدیل به یکی از شعب ایرانیان پوشش شود که خوشبختانه از طریق سوپر اپلیکیشن سپر و ایجاد شعبه در تمام مراکز استانهای کشور و کارشناس سیار در شهرستا های تابعه توانسته به این اهداف بزرگ برسد.                                         <br/>
                                    ما در صدد هستیم تا ۵ سال دیگر به جایگاه ذیل دست یابیم:
                                    <br/>
                                        • تبدیل شدن به تخصصی‌ترین و بزرگترین شرکت ارزیابی خسارت و ریسک در تمامی حوزه های بیمه ای
                                        <br/>
                                        •  تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات وکالت و داوری در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات تحقیق و کارآگاهی در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • هلدینگ ایرانیان پوشش بدون رقیب در حوزه ارزیابی خسارت و خدمات حقوقی بیمه ای از نظر کیفیت، قیمت و سرعت مبتنی بر تکنولوژی در ارائه خدمات خواهد بود.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>

    ) : (
                <div>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                    <Center>
                                        <Margin top={4}>
                                            <div>
                                                <p className="cardTitleMobile"><strong>چشم انداز ۱۴۰۱</strong></p>
                                            </div>
                                        </Margin>
                                    </Center>
                                    <Center>
                                        <div style={{ marginTop: "-10px" }} className="cardTitleHRMobile"></div>
                                    </Center>
                                    <Margin top={2}></Margin>
                                    <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                    <p className="textParagraphMobile">
                                    ایرانیان با شعار مراقب بیمه ( حافظ رابطه بیمه گر و بیمه گذار) بر آن شد در ده سال اول یعنی  تا سال ۱۴۰۱ همه ایران را پوشش دهد و جیب هر ایرانی تبدیل به یکی از شعب ایرانیان پوشش شود که خوشبختانه از طریق سوپر اپلیکیشن سپر و ایجاد شعبه در تمام مراکز استانهای کشور و کارشناس سیار در شهرستا های تابعه توانسته به این اهداف بزرگ برسد.                                         <br/>
                                    ما در صدد هستیم تا ۵ سال دیگر به جایگاه ذیل دست یابیم:
                                    <br/>
                                        • تبدیل شدن به تخصصی‌ترین و بزرگترین شرکت ارزیابی خسارت و ریسک در تمامی حوزه های بیمه ای
                                        <br/>
                                        •  تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات وکالت و داوری در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • تبدیل شدن به بزرگترین و حرفه‌ای ترین شرکت ارائه دهنده خدمات تحقیق و کارآگاهی در حوزه‌های مختلف بیمه ای
                                        <br />
                                        • هلدینگ ایرانیان پوشش بدون رقیب در حوزه ارزیابی خسارت و خدمات حقوقی بیمه ای از نظر کیفیت، قیمت و سرعت مبتنی بر تکنولوژی در ارائه خدمات خواهد بود.
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                </div>
            );
};

export default Vision;
